import actionTypes from "../../actions/actionTypes";

const initialState = {
  unlockUserAccountLoader: false,
  toggleUserStatusLoader: false,
  isLoginIdExistsLoader: false,
  getCountryListLoader: false,
  getStateListLoader: false,
  getCityListLoader: false,
  getWorkOfficeListLoader: false,
  getProductCategoryListLoader: false,
  getUserGroupsLoader: false,
  getAllRolesLoader: false,
  postUserProfileLoader: false,
  putUserProfileLoader: false,
};

const userManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.userManagementTypes.UNLOCK_USER_ACCOUNT_LOADER:
      return {
        ...state,
        unlockUserAccountLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.TOGGLE_USER_STATUS_LOADER:
      return {
        ...state,
        toggleUserStatusLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.IS_LOGINID_EXISTS_LOADER:
      return {
        ...state,
        isLoginIdExistsLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_COUNTRY_LIST_LOADER:
      return {
        ...state,
        getCountryListLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_STATE_LIST_LOADER:
      return {
        ...state,
        getStateListLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_CITY_LIST_LOADER:
      return {
        ...state,
        getCityListLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_WORK_OFFICE_LIST_LOADER:
      return {
        ...state,
        getWorkOfficeListLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes
      .GET_PRODUCT_CATEGORY_LIST_LOADER:
      return {
        ...state,
        getProductCategoryListLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_USER_GROUPS_LOADER:
      return {
        ...state,
        getUserGroupsLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.GET_ALL_ROLES_LOADER:
      return {
        ...state,
        getAllRolesLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.POST_USER_PROFILE_LOADER:
      return {
        ...state,
        postUserProfileLoader: payload,
      };
    case actionTypes.adminTypes.userManagementTypes.PUT_USER_PROFILE_LOADER:
      return {
        ...state,
        putUserProfileLoader: payload,
      };
    default:
      return state;
  }
};

export default userManagementReducer;
